// A 4-way grid direction (tunnels, arrows, ...). Screen space, row 0 at the TOP (Y grows downward).
export var GridDirection;
(function (GridDirection) {
    GridDirection[GridDirection["Top"] = 0] = "Top";
    GridDirection[GridDirection["Bottom"] = 1] = "Bottom";
    GridDirection[GridDirection["Left"] = 2] = "Left";
    GridDirection[GridDirection["Right"] = 3] = "Right";
})(GridDirection || (GridDirection = {}));
